import * as imports from "../components/dynamic-imports";
import bulkDownload from "../tcbase/bulk_download";
import disableManagedSections from "../tcbase/central_config";
import connectapp from "../tcbase/connectapp";
import ExportGridMenu from "../tcbase/export_grid";
import toggleLoadingMask from "../tcbase/loadingmask";
import * as notifications from "../notifications/notifications";
import storage from "../tcbase/storage";
import Utils from "../tcbase/utils/index";
import { centralmanager } from "./jsbridge";

Object.assign((window.tcbase = window.tcbase || {}), {
  toggleLoadingMask,
  notifications,
  connectapp,
  storage,
  ExportGridMenu,
  bulkDownload,
  centralManagerEnabled: centralmanager.enabled,
  disableManagedSections,
  ...imports
});

Object.assign((window.tcbase.utils = window.tcbase.utils || {}), Utils);

export default window.tcbase;
